import React from 'react';
import classnames from 'classnames';
import classes from './overlay.scss';
export let OverlayType = /*#__PURE__*/function (OverlayType) {
  OverlayType[OverlayType["fullScreen"] = 0] = "fullScreen";
  OverlayType[OverlayType["searchOverlay"] = 1] = "searchOverlay";
  OverlayType[OverlayType["searchOverlayWithCategories"] = 2] = "searchOverlayWithCategories";
  return OverlayType;
}({});
export let OverlayBackgroundType = /*#__PURE__*/function (OverlayBackgroundType) {
  OverlayBackgroundType[OverlayBackgroundType["semiTransparent"] = 0] = "semiTransparent";
  OverlayBackgroundType[OverlayBackgroundType["transparent"] = 1] = "transparent";
  return OverlayBackgroundType;
}({});
const Overlay = ({
  isShown,
  overlayingType = OverlayType.fullScreen,
  backgroundType = OverlayBackgroundType.semiTransparent
}) => isShown ? /*#__PURE__*/React.createElement("div", {
  className: classnames({
    [classes.overlay]: overlayingType === OverlayType.fullScreen,
    [classes.searchOverlay]: overlayingType === OverlayType.searchOverlay,
    [classes.withCategories]: overlayingType === OverlayType.searchOverlayWithCategories,
    [classes.transparent]: backgroundType === OverlayBackgroundType.transparent,
    [classes.semiTransparent]: backgroundType === OverlayBackgroundType.semiTransparent
  })
}) : null;
export default Overlay;